import { PickUpDTO } from "./pickup.dto";
import { Injectable } from "@nestjs/common";
import { PickUp } from "../pickup.entity";

@Injectable()
export class PickUpAdapter{

    public convertDtoToEntity(pickUpDTO: PickUpDTO, isUpdate: boolean = false): PickUp{
        const pickUpEntity = new PickUp();
        pickUpEntity.pickUpId= pickUpDTO.pickUpId
        pickUpEntity.pickUp = pickUpDTO.pickUp;
        pickUpEntity.isActive = pickUpDTO.isActive === undefined ? true : pickUpDTO.isActive;
        // pickUpEntity.route = pickUpDTO.route;
        if(isUpdate){
            pickUpEntity.updatedUser = pickUpDTO.updatedUser;
        }else{
            pickUpEntity.isActive = true;
            pickUpEntity.createdUser = pickUpDTO.createdUser;
        }
        return pickUpEntity;
    }

    public convertEntityToDto(pickUpObj: PickUp): PickUpDTO{
        const pickUpDTO = new PickUpDTO;
        pickUpDTO.pickUpId= pickUpObj.pickUpId
        pickUpDTO.pickUp = pickUpObj.pickUp;
        pickUpDTO.isActive = pickUpObj.isActive;
        pickUpDTO.createdAt = pickUpObj.createdAt;
        pickUpDTO.updatedAt = pickUpObj.updatedAt;
        pickUpDTO.updatedUser = pickUpObj.updatedUser;
        pickUpDTO.createdUser = pickUpObj.createdUser;
        pickUpDTO.versionFlag = pickUpObj.versionFlag;
        return pickUpDTO;

    }
}